import { useState, useMemo, useEffect, useCallback } from 'react';
import { cloneDeep } from 'lodash-es';

export const useFacade = (allCategories, setAllCategories) => {
  const [isOpen, setIsOpen] = useState(false);
  const [search, setSearch] = useState('');
  const [isChanged, setIsChanged] = useState(true);

  const [localStateCategories, setLocalStateCategories] = useState([]);

  useEffect(() => {
    if (allCategories?.length > 0) setLocalStateCategories(allCategories);
  }, [allCategories]);

  useEffect(() => {
    const res = localStateCategories
      .filter((a) => a?.isGlobal || a.selected)
      .concat(localStateCategories.filter((a) => !a?.isGlobal && !a.selected));
    setLocalStateCategories(res);
  }, [search, isOpen]);

  const sortCategories = (categories) => {
    const sortedCategories = categories
      .filter((a) => a.selected)
      .concat(categories.filter((a) => !a.selected));
    return sortedCategories;
  };

  const checkName = (name, search) => {
    return name?.toLowerCase().includes(search.toLowerCase());
  };

  const foundedCategories = useMemo(() => {
    if (!search) return localStateCategories;
    return localStateCategories.filter((category) => checkName(category.text, search));
  }, [search, localStateCategories]);

  const selectCategory = useCallback(
    (isChecked, value) => {
      if (isChanged) setIsChanged(false);
      const newCategories = cloneDeep(localStateCategories);
      const currentItemIndex = newCategories.findIndex((item) => item.value === value);
      newCategories[currentItemIndex] = {
        ...newCategories[currentItemIndex],
        selected: isChecked,
      };
      setLocalStateCategories(newCategories);
    },
    [localStateCategories],
  );

  const handleSearchOnChange = useCallback((e) => {
    setSearch(e.target.value || '');
  }, []);

  const handleClearSearchValue = useCallback(() => {
    setSearch('');
    setAllCategories(sortCategories(allCategories));
  }, []);

  const btnDeselectAll = useMemo(
    () => (localStateCategories.find((item) => item.selected === true) ? true : false),
    [localStateCategories],
  );

  const handleDeselectAll = useCallback(() => {
    if (isChanged) setIsChanged(false);
    const newCategories = cloneDeep(localStateCategories);
    newCategories.forEach((item) => (item.selected = false));
    setLocalStateCategories(newCategories);
  }, [isOpen, localStateCategories]);

  const saveButtonAction = useCallback(() => {
    setAllCategories(localStateCategories);
    setSearch('');
    setIsOpen(false);
  }, [isOpen, localStateCategories]);

  const hadleCloseWindow = useCallback(() => {
    setIsOpen(false);
    setSearch('');
    setLocalStateCategories(allCategories);
  }, [isOpen]);

  return {
    setIsOpen,
    isOpen,
    hadleCloseWindow,
    search,
    handleSearchOnChange,
    handleClearSearchValue,
    btnDeselectAll,
    handleDeselectAll,
    selectCategory,
    foundedCategories,
    saveButtonAction,
    isChanged,
  };
};
